var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPer2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_22_1",
    "data-name": "Component 22 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#409ddb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rotate_right_black_24dp",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M0,0H38.982V38.982H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M22.76,8.39,15.37,1V5.986a12.981,12.981,0,0,0,0,25.76V28.466a9.734,9.734,0,0,1,0-19.2v6.351Zm7.114,8.852a12.841,12.841,0,0,0-2.631-6.318l-2.306,2.306a9.43,9.43,0,0,1,1.657,4.012ZM18.618,28.45v3.281a12.87,12.87,0,0,0,6.335-2.615l-2.339-2.339a9.4,9.4,0,0,1-4,1.673Zm6.318-3.931,2.306,2.29a12.841,12.841,0,0,0,2.631-6.318H26.593A9.578,9.578,0,0,1,24.936,24.519Z",
    transform: "translate(2.497 0.624)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPer2);
export default __webpack_public_path__ + "static/media/per_2.f4058d44e48954865a476d43322edfad.svg";
export { ForwardRef as ReactComponent };